module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Black.13d879f.woff2";